import React from "react";
import { DataGrid } from "@mui/x-data-grid";

export default function DataGridComponent({
  data,
  columns,
  rowHeight = 50,
  className,
  columnHide,
}) {
  return (
    <div className="dataGridTable">
      <DataGrid
        rows={data}
        columns={columns}
        columnHeaderHeight={40}
        viewColumns={false}
        disableColumnFilter
        rowHeight={rowHeight}
        hideFooter={true}
        className={className ? className : ""}
        slots={
          columnHide && {
            columnHeaders: () => null,
          }
        }
      />
    </div>
  );
}
